import {
    CREATOR_VALUE_SET,
    DENOM_ID_VALUE_SET,
    HIDE_PARTICIPATION_NFT_PREVIEW_DIALOG,
    INITIAL_NFT_INDEX_VALUE_SET,
    MINTED_UNTIL_TIME_SET,
    NFT_SELECT_COLLECTIONS_SET,
    PARTICIPATION_NFT_AUTHZ_ADDRESS_FETCH_ERROR,
    PARTICIPATION_NFT_AUTHZ_ADDRESS_FETCH_IN_PROGRESS,
    PARTICIPATION_NFT_AUTHZ_ADDRESS_FETCH_SUCCESS,
    PARTICIPATION_NFT_FETCH_ERROR,
    PARTICIPATION_NFT_FETCH_IN_PROGRESS,
    PARTICIPATION_NFT_FETCH_SUCCESS,
    PARTICIPATION_NFT_GRANTER_INFO_FETCH_ERROR,
    PARTICIPATION_NFT_GRANTER_INFO_FETCH_IN_PROGRESS,
    PARTICIPATION_NFT_GRANTER_INFO_FETCH_SUCCESS,
    PARTICIPATION_NFT_SWITCH_SET,
    REQUIRED_SCORE_PERCENTAGE_SET,
    ROYALITY_SHARE_VALUE_SET,
    SHOW_PARTICIPATION_NFT_PREVIEW_DIALOG,
    TOTAL_UNITS_SET,
    VIDEO_DROPS_CANCEL_FETCH_COLLECTIONS,
    VIDEO_DROPS_COLLECTIONS_FETCH_ERROR,
    VIDEO_DROPS_COLLECTIONS_FETCH_IN_PROGRESS,
    VIDEO_DROPS_COLLECTIONS_FETCH_SUCCESS,
    VIDEO_DROPS_COUNTER_SWITCH_SET,
    VIDEO_DROPS_DESCRIPTION_SET,
    VIDEO_DROPS_DUPLICATE_KEYS_SET,
    VIDEO_DROPS_DYNAMIC_DATA_SWITCH_SET,
    VIDEO_DROPS_DYNAMIC_SCHEMA_SET,
    VIDEO_DROPS_EXTENSIBILITY_SWITCH_SET,
    VIDEO_DROPS_FIELDS_CLEAR_SET,
    VIDEO_DROPS_MEDIA_URL_SET,
    VIDEO_DROPS_NAME_SET,
    VIDEO_DROPS_NSFW_SWITCH_SET,
    VIDEO_DROPS_PARTICIPANT_DATA_SWITCH_SET,
    VIDEO_DROPS_PREVIEW_URL_SET,
    VIDEO_DROPS_ROYALTY_SWITCH_SET,
    VIDEO_DROPS_STATIC_DATA_SWITCH_SET,
    VIDEO_DROPS_STATIC_SCHEMA_SET,
    VIDEO_DROPS_TRANSFERABILITY_SWITCH_SET,
    VIDEO_DROPS_TWEET_TEXT_SET,
} from '../../constants/interactiveVideos/videoDrops';
import { urlFetchNonContractCollections } from '../../constants/restURL';
import Axios from 'axios';
import { handleErrorMessage } from '../../utils/errorMessages';
import {
    PARTICIPATION_NFT_AUTHZ_ADDRESS_URL,
    urlFetchParticipationNftConfig,
} from '../../constants/url';
import { config } from '../../config';

export const setParticipationNftEnable = (value) => {
    return {
        type: PARTICIPATION_NFT_SWITCH_SET,
        value,
    };
};

export const setTotalUnits = (value) => {
    return {
        type: TOTAL_UNITS_SET,
        value,
    };
};

export const setInitialNftIndexValue = (value) => {
    return {
        type: INITIAL_NFT_INDEX_VALUE_SET,
        value,
    };
};

export const setCounterSwitch = (value) => {
    return {
        type: VIDEO_DROPS_COUNTER_SWITCH_SET,
        value,
    };
};

export const setDenomIdValue = (value) => {
    return {
        type: DENOM_ID_VALUE_SET,
        value,
    };
};

export const setCreatorValue = (value) => {
    return {
        type: CREATOR_VALUE_SET,
        value,
    };
};

export const setVideoDropsName = (value) => {
    return {
        type: VIDEO_DROPS_NAME_SET,
        value,
    };
};

export const setVideoDropsDescription = (value, valid) => {
    return {
        type: VIDEO_DROPS_DESCRIPTION_SET,
        value,
        valid,
    };
};

export const setRoyalitySwitch = (value) => {
    return {
        type: VIDEO_DROPS_ROYALTY_SWITCH_SET,
        value,
    };
};

export const setRoyalityShareValue = (value) => {
    return {
        type: ROYALITY_SHARE_VALUE_SET,
        value,
    };
};

export const setTransferabilitySwitch = (value) => {
    return {
        type: VIDEO_DROPS_TRANSFERABILITY_SWITCH_SET,
        value,
    };
};

export const setExtensibilitySwitch = (value) => {
    return {
        type: VIDEO_DROPS_EXTENSIBILITY_SWITCH_SET,
        value,
    };
};

export const setNSFWSwitch = (value) => {
    return {
        type: VIDEO_DROPS_NSFW_SWITCH_SET,
        value,
    };
};

export const setVideoDropsTweetText = (value, tweetLength) => {
    return {
        type: VIDEO_DROPS_TWEET_TEXT_SET,
        value,
        tweetLength,
    };
};

export const setVideoDropsPreviewURL = (value) => {
    return {
        type: VIDEO_DROPS_PREVIEW_URL_SET,
        value,
    };
};

export const setVideoDropsMediaURL = (value, mediaType) => {
    return {
        type: VIDEO_DROPS_MEDIA_URL_SET,
        value,
        mediaType,
    };
};

const fetchVideoDropCollectionsInProgress = () => {
    return {
        type: VIDEO_DROPS_COLLECTIONS_FETCH_IN_PROGRESS,
    };
};

const fetchVideoDropCollectionsSuccess = (value, skip, limit, search, total) => {
    return {
        type: VIDEO_DROPS_COLLECTIONS_FETCH_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchVideoDropCollectionsError = (message) => {
    return {
        type: VIDEO_DROPS_COLLECTIONS_FETCH_ERROR,
        message,
    };
};

const cancelFetchVideoDropCollections = (cancel) => {
    return {
        type: VIDEO_DROPS_CANCEL_FETCH_COLLECTIONS,
        cancel,
    };
};

export const fetchVideoDropCollections = (address, skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchVideoDropCollectionsInProgress());

    const url = urlFetchNonContractCollections(address, skip, limit, search);
    const CancelToken = Axios.CancelToken;
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
        cancelToken: new CancelToken((cancel) => {
            dispatch(cancelFetchVideoDropCollections(cancel));
        }),
    })
        .then((res) => {
            dispatch(fetchVideoDropCollectionsSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchVideoDropCollectionsError(message));

            if (cb) {
                cb(null);
            }
        });
};

export const setNFTSelectCollections = (value, valid) => {
    return {
        type: NFT_SELECT_COLLECTIONS_SET,
        value,
        valid,
    };
};

export const updateParticipantNFTConfigInProgress = () => {
    return {
        type: PARTICIPATION_NFT_FETCH_IN_PROGRESS,
    };
};

export const updateParticipantNFTConfigSuccess = (value, message) => {
    return {
        type: PARTICIPATION_NFT_FETCH_SUCCESS,
        value,
        message,
        variant: 'success',
    };
};

export const updateParticipantNFTConfigError = (message) => {
    return {
        type: PARTICIPATION_NFT_FETCH_ERROR,
        message,
    };
};

export const updateParticipantNFTConfig = (id, data, cb) => (dispatch) => {
    dispatch(updateParticipantNFTConfigInProgress());

    const url = urlFetchParticipationNftConfig(id);
    Axios.put(url, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(updateParticipantNFTConfigSuccess(res.data && res.data.result, 'Success'));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(updateParticipantNFTConfigError(message));

            if (cb) {
                cb(null);
            }
        });
};

export const participantNFTAuthzAccountAddressInProgress = () => {
    return {
        type: PARTICIPATION_NFT_AUTHZ_ADDRESS_FETCH_IN_PROGRESS,
    };
};

export const participantNFTAuthzAccountAddressSuccess = (value, message) => {
    return {
        type: PARTICIPATION_NFT_AUTHZ_ADDRESS_FETCH_SUCCESS,
        value,
        message,
        variant: 'success',
    };
};

export const participantNFTAuthzAccountAddressError = (message) => {
    return {
        type: PARTICIPATION_NFT_AUTHZ_ADDRESS_FETCH_ERROR,
        message,
    };
};

export const fetchParticipantNFTAuthzAccountAddress = () => (dispatch) => {
    dispatch(participantNFTAuthzAccountAddressInProgress());

    Axios.get(PARTICIPATION_NFT_AUTHZ_ADDRESS_URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(participantNFTAuthzAccountAddressSuccess(res.data && res.data.result, 'Success'));
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(participantNFTAuthzAccountAddressError(message));
        });
};

export const setVideoDropsClear = () => {
    return {
        type: VIDEO_DROPS_FIELDS_CLEAR_SET,
    };
};

export const setRequiredPercentageValue = (value) => {
    return {
        type: REQUIRED_SCORE_PERCENTAGE_SET,
        value,
    };
};

export const setMintedUntilValue = (value, inValid) => {
    return {
        type: MINTED_UNTIL_TIME_SET,
        value,
        inValid,
    };
};

export const showParticipantNftPreviewDialog = (value, url, mediaType) => {
    return {
        type: SHOW_PARTICIPATION_NFT_PREVIEW_DIALOG,
        value,
        url,
        mediaType,
    };
};

export const hideParticipantNftPreviewDialog = () => {
    return {
        type: HIDE_PARTICIPATION_NFT_PREVIEW_DIALOG,
    };
};

export const setStaticDataSwitch = (value) => {
    return {
        type: VIDEO_DROPS_STATIC_DATA_SWITCH_SET,
        value,
    };
};

export const setDynamicDataSwitch = (value) => {
    return {
        type: VIDEO_DROPS_DYNAMIC_DATA_SWITCH_SET,
        value,
    };
};

export const setParticipantDataSwitch = (value, totalQuestions, questionsAnswered, correctAnswers) => {
    return {
        type: VIDEO_DROPS_PARTICIPANT_DATA_SWITCH_SET,
        value,
        totalQuestions,
        questionsAnswered,
        correctAnswers,
    };
};

export const setStaticSchema = (value, valid) => {
    return {
        type: VIDEO_DROPS_STATIC_SCHEMA_SET,
        value,
        valid,
    };
};

export const setDynamicSchema = (value, valid) => {
    return {
        type: VIDEO_DROPS_DYNAMIC_SCHEMA_SET,
        value,
        valid,
    };
};

const fetchGranterInfoInProgress = () => {
    return {
        type: PARTICIPATION_NFT_GRANTER_INFO_FETCH_IN_PROGRESS,
    };
};

const fetchGranterInfoSuccess = (value) => {
    return {
        type: PARTICIPATION_NFT_GRANTER_INFO_FETCH_SUCCESS,
        value,
    };
};

const fetchGranterInfoError = (message) => {
    return {
        type: PARTICIPATION_NFT_GRANTER_INFO_FETCH_ERROR,
        message,
    };
};

export const fetchGranterInfo = (address, cb) => (dispatch) => {
    dispatch(fetchGranterInfoInProgress());

    const url = config.REST_URL + '/cosmos/authz/v1beta1/grants/granter/' + address;
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(fetchGranterInfoSuccess(res.data));
            if (cb) {
                cb(res.data);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchGranterInfoError(message));

            cb(null);
        });
};

export const setDropsDuplicateKeys = (value) => {
    return {
        type: VIDEO_DROPS_DUPLICATE_KEYS_SET,
        value,
    };
};
